<template>
	<div class="admin-author-profile">
		<div class="vx-row">
			<div class="vx-col lg:w-1/4 w-full mb-10">
				<vx-card>
					<div class="flex justify-between items-center box-top admin-author-profile-widget">
						<div class="des w-full">
							<div class="admin-author-profile-widget__big">{{ countTask.count }}</div>
							<p>{{ $t('totalOrdersCount') }}</p>
						</div>
						<div class="icon">
							<feather-icon icon="ListIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col lg:w-1/4 w-full mb-10">
				<vx-card>
					<div class="flex justify-between items-center box-top admin-author-profile-widget">
						<div class="des">
							<div class="admin-author-profile-widget__big">
								<span class="admin-author-profile-widget__success">{{ countTaskActive.count_success }}</span>
								/
								<span class="admin-author-profile-widget__danger">{{ countTaskActive.count_fail }}</span>
							</div>
							<p>{{ $t('success') }}</p>
						</div>
						<div class="icon">
							<feather-icon icon="ThumbsUpIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
		</div>

		<div class="vx-row">
			<div class="vx-col w-full mb-5">
				<vx-card>
					<h1>{{ $t('profile') }}</h1>
					<div class="info mt-5 flex flex-col sm:flex-row">
						<div class="photo">
							<img :src="model.photo" alt="">
						</div>
						<div class="data">
							<div class="tables vx-row">
								<table class="vx-col w-full lg:w-1/2">
									<tbody>
									<tr>
										<td>{{ $t('personName') }}</td>
										<td>{{model.first_name }} {{model.last_name }}</td>
									</tr>
									<tr>
										<td>{{ $t('nickname') }}</td>
										<td>{{model.username }}</td>
									</tr>
									<tr>
										<td>Email</td>
										<td>{{model.email }}</td>
									</tr>
									<tr>
										<td>{{ $t('emailForPayment') }}</td>
										<td>{{model.email_payment }}</td>
									</tr>
									<tr>
										<td>{{ $t('phone') }}</td>
										<td>{{model.phone }}</td>
									</tr>
									</tbody>
								</table>
								<table class="vx-col w-full lg:w-1/2 mt-10 lg:mt-0">
									<tbody>
									<tr>
										<td>{{ $t('birthDate') }}</td>
										<td>{{ birthDateOutput }}</td>
									</tr>
									<tr>
										<td>{{ $t('sex') }}</td>
										<td>{{ $getDeep(model.gender, genders) }}</td>
									</tr>
									<tr>
										<td>{{ $t('country') }}</td>
										<td>{{ $getDeep(model.country, countries) }}</td>
									</tr>
									<tr>
										<td>{{ $t('language') }}</td>
										<td>
											<div class="d-flex flex-wrap">
												{{ languagesOutput }}
											</div>
										</td>
									</tr>
									<tr>
										<td>{{ $t('subjects') }}</td>
										<td>
											<div class="d-flex flex-wrap">
												{{ subjectsOutput }}
											</div>
										</td>
									</tr>
									</tbody>
								</table>
							</div>
							<div class="about">
								<b>{{ $t('aboutYourself') }}</b>
								<p>{{model.about }}</p>
							</div>
						</div>
					</div>
					<vs-button
						v-if="this.$store.state.auth.role === 'admin'"
						@click="$router.push($route.path+'/edit')"
						class="mr-5 mt-10 edit-btn"
					>{{ $t('edit') }}</vs-button>
					<vs-button
						v-if="this.$store.state.auth.role === 'admin'"
						@click="$router.push($route.path+'/tariff-point')"
						class="mr-5 mt-10 edit-btn"
					>{{ $t('tariffSchedule') }}</vs-button>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Author",
	data() {
		return {
			popupActive: false,
			val: '',
			description: '',
			countries: [],
			genders: [],
			languages: [],
			subjects: [],
			countTask: {},
			countTaskActive: {},
			model: {}
		}
	},
	computed: {
		locale() {
			return this.$store.state.locale;
		},
		languagesOutput() {
			if(!this.model === undefined || !this.model.languages) return null;

			return this.model.languages[0][`name_${this.locale}`];
		},
		subjectsOutput() {
			if(!this.model === undefined || !this.model.subjects) return null;

			let output = [];
			for(let subject of this.model.subjects) {
				output.push(this.$getDeep(subject, this.subjects));
			}
			return output.join(", ");
		},
		birthDateOutput() {
			if(!this.model === undefined || !this.model.birth_date) return null;

			return this.model.birth_date
				.split('-')
				.reverse()
				.join('.');
		}
	},
	async mounted() {
		try {
			const role = this.$store.state.auth.role;

			this.languages = (await this.$http.get('/settings/get-languages')).data.data;
			this.subjects =  (await this.$http.get('/settings/get-subjects')).data.data;
			this.countries = (await this.$http.get('/settings/get-countries')).data.data
			this.genders = (await this.$http.get('/settings/get-genders')).data.data;

			if(role === "admin") {
				this.model = (await this.$http(`/${role}/author/view/${this.$route.params.id}`)).data.data;
			} else if(role === "manager") {
				this.model = (await this.$http(`/${role}/author/profile/${this.$route.params.id}`)).data.data;
			} else if(role === "supervisor") {
				this.model = (await this.$http(`/${role}/author/profile/${this.$route.params.id}`)).data.data;
			}

			this.countTask = (await this.$http.get(`/${role}/author/get-orders-completed-count/${this.$route.params.id}`)).data.data;
			this.countTaskActive = (await this.$http.get(`/${role}/author/get-success-rate/${this.$route.params.id}`)).data.data;
		} catch (e) {
			console.log(e);
		}
	},
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.admin-author-profile {
	.data {
		width: 100%;
	}

	&-widget {
		&__big {
			font-size: 18px;
			font-weight: 600;
		}

		&__success {
			color: $success;
		}

		&__danger {
			color: $danger;
		}
	}

	h1 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
		font-weight: 700;
	}

	.vx-card {
		height: 100%;
	}

	.info {
		display: flex;

		.tables {
			display: flex;
		}

		table {
			max-width: 550px;
			margin-bottom: 20px;
			padding-left: 15px;

			tr {

				td {
					padding-bottom: 7px;
					width: 50%;

					&:first-child {
						vertical-align: top;
						max-width: 250px;
						font-weight: 600;
					}
				}

			}
		}

		.about {
			display: flex;

			b {
				flex-shrink: 0;
				max-width: 258px;
				width: 25%;
			}

			@media screen and (max-width: 992px) {
				b {
					width: 50%;
				}
			}
		}
	}

	.photo {
		width: 200px;
		height: 200px;
		border-radius: 10px;
		overflow: hidden;
		margin-right: 30px;
		margin-bottom: 15px;
		flex-shrink: 0;


		img {
			max-width: 100%;
			width: 100%;
			height: 100%;
		}
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
	}

	.edit-btn {
		width: 100%;
		max-width: 200px;
	}
}

</style>
